// Missions.styles.ts

import styled, { createGlobalStyle } from 'styled-components';

export const NavBar = styled.div`
  position: fixed;
  top: 0;
  padding-top: 10rem;
  padding-bottom: 0.5rem;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 999;

  @media (max-width: 768px) {
    padding-top: 5.5rem;
  }
`;

export const NavTabs = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const NavTab = styled.a<{ $active: boolean }>`
  text-decoration: none;
  font-weight: bold;
  padding: 0.5rem 0.5rem;
  border: 2px solid
    ${(props) => (props.$active ? 'var(--color-new-button)' : props.theme.primary)};
  border-radius: 5px;
  background-color: ${(props) =>
    props.$active ? props.theme.sealBrown : props.theme.background};
  color: ${(props) =>
    props.$active ? 'var(--color-new-button)' : props.theme.primary};
  transform: ${(props) => (props.$active ? 'translateY(-2px)' : 'none')};
  transition: color 0.3s ease, transform 0.3s ease, background-color 0.3s ease;

  &:hover {
    color: var(--color-new-button);
    background-color: ${(props) => props.theme.sealBrown};
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    font-weight: bold;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
  margin-top: 3rem; /* Space for the fixed NavBar tabs */

  @media (max-width: 768px) {
    margin-top: 2rem;
  }
`;

export const SectionWrapper = styled.div`
  position: relative;
  padding: 3rem 0;
  min-height: 20vh;

  &:first-child {
    padding-top: 1rem;
  }

  @media (max-width: 768px) {
    padding: 2rem 0;

    &:first-child {
      padding-top: 0.5rem;
    }
  }
`;

export const GlassContainer = styled.div`
    width: 80vw;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 3rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease, transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 36px rgba(0, 0, 0, 0.15);
  }
    // maximize the width in smaller screens
  @media (max-width: 768px) {
    padding: 0.5rem;
    padding-top: 7rem;
    width: 95vw;
  }
`;

export const AboutSection = styled.section`
  position: relative;
  line-height: 1.8;
  color: ${(props) => props.theme.text};
  font-size: 1.1rem;

  .image-and-first {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 2rem;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    margin-bottom: 2rem;
    overflow: hidden;

    img {
      width: 300px;
      height: 300px;
      object-fit: cover;
      flex-shrink: 0;
      border-radius: 8px 0 0 8px;
    }

    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #fafafa;
      padding: 1.5rem;
      border-radius: 0 8px 8px 0;
      min-height: 300px;
    }
  }

  .rest-of-paragraphs {
    position: relative;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &::before {
      content: "";
      position: absolute;
      left: 30px;
      top: 0;
      bottom: 0;
      width: 2px;
      background-color: #ccc;
    }

    > div {
      position: relative;
      width: 100%;
      max-width: 800px;
      background-color: #ffffff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      padding: 1.5rem;
      margin-left: 4rem;
      margin-bottom: 2rem;

      &::after {
        content: "";
        position: absolute;
        left: -32px;
        top: 2rem;
        width: 34px;
        height: 2px;
        background-color: #ff5722;
      }

      &::before {
        content: "";
        position: absolute;
        left: calc(10px - 8px);
        top: 1.5rem;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: linear-gradient(135deg, #ff5722, #ff9800);
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      }

      &:nth-child(1)::before,
      &:nth-child(1)::after {
        background: linear-gradient(135deg, #ff5722, #ff9800);
      }

      &:nth-child(2)::before,
      &:nth-child(2)::after {
        background: linear-gradient(135deg, #4CAF50, #81C784);
      }

      &:nth-child(3)::before,
      &:nth-child(3)::after {
        background: linear-gradient(135deg, #2196F3, #64B5F6);
      }

      &:nth-child(4)::before,
      &:nth-child(4)::after {
        background: linear-gradient(135deg, #9C27B0, #BA68C8);
      }

      &:nth-child(5)::before,
      &:nth-child(5)::after {
        background: linear-gradient(135deg, #E91E63, #F06292);
      }
    }
  }

  @media (max-width: 768px) {
    .image-and-first {
      flex-direction: column;

      img {
        width: 100%;
        height: auto;
        margin-bottom: 1rem;
        border-radius: 8px 8px 0 0;
      }

      > div {
        border-radius: 0 0 8px 8px;
        min-height: auto;
      }
    }

    .rest-of-paragraphs {
      align-items: flex-start;

      &::before {
        display: none;
      }

      > div {
        margin-left: 0;

        &::after,
        &::before {
          display: none;
        }
      }
    }
  }

  h2 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }
`;

// ImageAndFirst Styled Component
export const ImageAndFirst = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 2rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 2rem;
  overflow: hidden;

  img {
    width: 300px;
    height: 300px;
    object-fit: cover;
    flex-shrink: 0;
    border-radius: 8px 0 0 8px;
  }

  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #fafafa;
    padding: 1.5rem;
    border-radius: 0 8px 8px 0;
    min-height: 300px;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    img {
      width: 100%;
      height: auto;
      margin-bottom: 1rem;
      border-radius: 8px 8px 0 0;
    }

    > div {
      border-radius: 0 0 8px 8px;
      min-height: auto;
    }
  }
`;

// RestParagraphs Styled Component
export const RestParagraphs = styled.div`
  position: relative;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &::before {
    content: "";
    position: absolute;
    left: 30px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #ccc;
  }

  > div {
    position: relative;
    width: 100%;
    max-width: 800px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 1.5rem;
    margin-left: 4rem;
    margin-bottom: 2rem;

    &::after {
      content: "";
      position: absolute;
      left: -32px;
      top: 2rem;
      width: 34px;
      height: 2px;
      background-color: #ff5722;
    }

    &::before {
      content: "";
      position: absolute;
      left: calc(10px - 8px);
      top: 1.5rem;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: linear-gradient(135deg, #ff5722, #ff9800);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }

    &:nth-child(1)::before,
    &:nth-child(1)::after {
      background: linear-gradient(135deg, #ff5722, #ff9800);
    }

    &:nth-child(2)::before,
    &:nth-child(2)::after {
      background: linear-gradient(135deg, #4CAF50, #81C784);
    }

    &:nth-child(3)::before,
    &:nth-child(3)::after {
      background: linear-gradient(135deg, #2196F3, #64B5F6);
    }

    &:nth-child(4)::before,
    &:nth-child(4)::after {
      background: linear-gradient(135deg, #9C27B0, #BA68C8);
    }

    &:nth-child(5)::before,
    &:nth-child(5)::after {
      background: linear-gradient(135deg, #E91E63, #F06292);
    }
  }

  @media (max-width: 768px) {
    align-items: flex-start;

    &::before {
      display: none;
    }

    > div {
      margin-left: 0;

      &::after,
      &::before {
        display: none;
      }
    }
  }
`;

export const HighlightGlobalStyle = createGlobalStyle`
  /* Keyframes for a subtle highlight pulse */
  @keyframes highlightPulse {
    0%, 100% {
      background-color: #fff59d;
    }
    50% {
      background-color: #ffeb3b;
    }
  }

  .highlighted-phrase {
    animation: highlightPulse 2s ease-in-out infinite;
    font-weight: bold;
    border-radius: 4px;
    padding: 2px 4px;
  }
`;
